module.exports = __webpack_public_path__ + "img/faq-sticker-status-sp.0294ec03.jpg";